// extracted by mini-css-extract-plugin
module.exports = {"heading":"CaptainOption_heading__ZZBVK","subTitle":"CaptainOption_subTitle__A0UE_","description":"CaptainOption_description__0mlE9","root":"CaptainOption_root__WVd5F"};